import React from "react";
import Navbar from "./common/Navbar";
import SubFooter from "./common/SubFooter";
import Footer from "./common/Footer";
import Expertise from "./inner-components/Expertise";
import Skill from "./inner-components/Skill";
import {
  DevOpsExpertiseArr,
  BackendExpertiseArr,
  FrontendExpertiseArr,
  DBExpertiseArr,
  ArchitectExpertiseArr,
  ORMExpertiseArr,
  SkillsArr,
} from "./data/SkillsData";

const Skills = () => {
  return (
    <React.Fragment>
      <main className="flex-shrink-0">
        <Navbar />
        <div className="container px-5">
          <div className="text-center mb-5">
            <h1 className="display-6 fw-bolder mb-0">
              <span className="text-gradient d-inline">Skills & Expertise</span>
            </h1>
          </div>
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-12 col-xl-12 col-xxl-10">
              <section>
                <div className="card shadow border-0 rounded-4 mb-5">
                  <div className="card-body p-5">
                    <div className="mb-0">
                      <div className="d-flex align-items-center mb-4">
                        <div className="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 me-3">
                          <i className="bi bi-code-slash"></i>
                        </div>
                        <h3 className="fw-bolder mb-0">
                          <span className="text-gradient d-inline">
                            Technology Stack
                          </span>
                        </h3>
                      </div>
                      <p className="text-muted mb-4">
                        Technologies and tools I use to design, develop, and
                        maintain scalable software solutions.
                      </p>
                      <h4 className="fw-bold text-gradient mb-4 border-bottom pb-2">
                        <i className="bi bi-gear-fill me-2 text-warning"></i>
                        Backend
                      </h4>
                      {BackendExpertiseArr.map((item) => (
                        <Expertise key={item} technologies={item} />
                      ))}
                      <h4 className="fw-bold text-gradient mb-4 border-bottom pb-2">
                        <i className="bi bi-window me-2 text-warning"></i>
                        Frontend
                      </h4>
                      {FrontendExpertiseArr.map((item) => (
                        <Expertise key={item} technologies={item} />
                      ))}
                      <h4 className="fw-bold text-gradient mb-4 border-bottom pb-2">
                        <i className="bi bi-diagram-3-fill me-2 text-warning"></i>
                        Architecture & Designs
                      </h4>
                      {ArchitectExpertiseArr.map((item) => (
                        <Expertise key={item} technologies={item} />
                      ))}
                      <h4 className="fw-bold text-gradient mb-4 border-bottom pb-2">
                        <i className="bi bi-layers me-2 text-warning"></i>
                        ORM & Data Access
                      </h4>
                      {ORMExpertiseArr.map((item) => (
                        <Expertise key={item} technologies={item} />
                      ))}
                      <h4 className="fw-bold text-gradient mb-4 border-bottom pb-2">
                        <i className="bi bi-server me-2 text-warning"></i>
                        Database
                      </h4>
                      {DBExpertiseArr.map((item) => (
                        <Expertise key={item} technologies={item} />
                      ))}
                      <h4 className="fw-bold text-gradient mb-4 border-bottom pb-2">
                        <i className="bi bi-cloud-arrow-up-fill me-2 text-warning"></i>
                        DevOps & Tools
                      </h4>
                      {DevOpsExpertiseArr.map((item) => (
                        <Expertise key={item} technologies={item} />
                      ))}
                    </div>
                  </div>
                </div>
                <div className="card shadow border-0 rounded-4 mb-5">
                  <div className="card-body p-5">
                    <div className="mb-0">
                      <div className="d-flex align-items-center mb-4">
                        <div className="feature bg-primary bg-gradient-primary-to-secondary text-white rounded-3 me-3">
                          <i className="bi bi-tools"></i>
                        </div>
                        <h3 className="fw-bolder mb-0">
                          <span className="text-gradient d-inline">
                            Core Expertise
                          </span>
                        </h3>
                      </div>
                      <p className="text-muted mb-4">
                        Areas of expertise developed through 14+ years of
                        backend engineering and technical leadership.
                      </p>
                      <div className="row g-3">
                        {SkillsArr.map((item) => (
                          <Skill key={item} skill={item} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <SubFooter />
      <Footer />
    </React.Fragment>
  );
};

export default Skills;
